import { Component } from '@angular/core';
import { Button } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 's-form-confirmation-prime-add',
  templateUrl: './confirmation-add.component.html',
  styleUrls: ['./confirmation-add.component.scss'],
  standalone: true,
  imports: [Button]
})
export class ConfirmationAddPrimeComponent {
  constructor(
    public ref: DynamicDialogRef,
    public dialogConfig: DynamicDialogConfig
  ) {}
  onNoClick(): void {
    this.ref.close(false);
  }
  close(_$event: Event): void {
    this.ref.close(false);
  }

  confirm(): void {
    this.ref.close(true);
  }
}
